module.exports = __webpack_public_path__ + "img/trash.113b8246.svg";